var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivities = function SvgActivities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80pt",
    height: "80pt",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ade6ff",
    d: "M3.594.879H26.87v26.168H.617V3.84A2.967 2.967 0 0 1 3.594.879m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50cdff",
    d: "M26.871.871H53.13v26.172H26.87zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ade6ff",
    d: "M53.129.879h23.277a2.967 2.967 0 0 1 2.977 2.96v23.208H53.129zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50cdff",
    d: "M.617 27.043h26.254v26.168H.617zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ade6ff",
    d: "M26.871 27.043H53.13v26.168H26.87zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50cdff",
    d: "M53.129 27.043h26.254v26.168H53.129zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ade6ff",
    d: "M.617 53.215h26.254v26.168H3.594a2.98 2.98 0 0 1-2.11-.871 2.94 2.94 0 0 1-.867-2.102zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50cdff",
    d: "M26.871 53.21H53.13v26.17H26.87zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ade6ff",
    d: "M53.129 53.215h26.254v23.203a2.97 2.97 0 0 1-2.977 2.965H53.13zm0 0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00a1dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.742 33.285a3.71 3.71 0 0 0-2.297-3.437 3.73 3.73 0 0 0-4.062.8 3.7 3.7 0 0 0-.809 4.047 3.72 3.72 0 0 0 3.442 2.297 3.72 3.72 0 0 0 3.726-3.707m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.586 36.992h-.848a.6.6 0 0 0-.12 0h-5.082a1 1 0 0 0-.141.012 1 1 0 0 0-.137-.012h-.852a1 1 0 0 0-.71.29 1.02 1.02 0 0 0-.298.71v4.84a1 1 0 0 0 .914.992v5.61c0 .671.547 1.218 1.223 1.218h4.961c.676 0 1.223-.547 1.223-1.218v-5.602c.5-.066.875-.488.875-.992V38a1 1 0 0 0-.293-.715 1 1 0 0 0-.715-.293m-24.469-2.551a14.4 14.4 0 0 0-5.355-1.082c-1.852.016-3.68.383-5.395 1.082a.52.52 0 0 0-.308.477v3.781a8.76 8.76 0 0 0 5.515 8.149.4.4 0 0 0 .196.043.4.4 0 0 0 .195-.043 8.74 8.74 0 0 0 5.472-8.149v-3.781a.53.53 0 0 0-.32-.477m0 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M15.734 40.129h-3.98a.544.544 0 0 0-.5.578c0 1.586 1.117 2.879 2.488 2.879 1.375 0 2.492-1.29 2.492-2.879a.54.54 0 0 0-.132-.39.54.54 0 0 0-.368-.188m-2.339-2.809a1.54 1.54 0 1 0-3.077.001 1.54 1.54 0 0 0 3.077 0m3.773-.001a1.536 1.536 0 1 0-3.074 0 1.537 1.537 0 1 0 3.074 0m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1dc",
    d: "M45.625 10.453h-1.687a.63.63 0 0 1-.555-.402l-.438-1.309a.62.62 0 0 0-.554-.398h-4.782a.62.62 0 0 0-.554.398l-.438 1.309a.63.63 0 0 1-.554.402h-1.688a1.41 1.41 0 0 0-1.41 1.402v6.305a1.414 1.414 0 0 0 1.41 1.406h11.25a1.416 1.416 0 0 0 1.41-1.406v-6.293a1.416 1.416 0 0 0-1.41-1.414m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M42.598 14.656c0-1.43-1.164-2.586-2.598-2.586s-2.598 1.157-2.598 2.586 1.164 2.59 2.598 2.59 2.598-1.16 2.598-2.59M16.203 71.902H5.133l5.23-10.59.305-.624.309.624zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a4e0",
    d: "M9.031 71.902h3.278l-1.547-3.945-.094-.234-.09.234zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1dc",
    d: "M22.352 71.902h-6.149l-5.535-11.215h5.996zM43.64 62.02a5.64 5.64 0 0 0-7.85.714 5.596 5.596 0 0 0 .565 7.84c.333.285.227.809.125 1.23l-.214.977a.39.39 0 0 0 .117.375c.105.094.25.125.387.082l4.835-1.57.055-.02a5.7 5.7 0 0 0 3.719-7.011 5.6 5.6 0 0 0-1.738-2.617m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M34.223 61.852a2.45 2.45 0 0 1 3.363-.797 2.43 2.43 0 0 1 .8 3.347c-.097.164.016.364.114.524l.223.375a.18.18 0 0 1 0 .168.18.18 0 0 1-.153.09h-2.246a2.483 2.483 0 0 1-2.48-2.395c0-.465.133-.922.379-1.312m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1dc",
    d: "m68.64 71.512-1.882-.555v-4.852h-.883v4.852l-1.883.555c-.281.086-.203.39.098.39h4.45c.3 0 .378-.304.1-.39m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M67.074 67.04a2.5 2.5 0 0 1-.379.07c-.37.05-.746.027-1.11-.067h-.022c-2.7-.711-2.797-2.777-2.422-4.363a8.3 8.3 0 0 1 .62-1.715.48.48 0 0 1 .438-.262h4.246c.18 0 .348.102.434.262q.404.821.621 1.715c.371 1.578.273 3.648-2.426 4.36m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1dc",
    d: "M19.371 13.926c0-3.078-2.52-5.574-5.629-5.574-3.105 0-5.625 2.496-5.625 5.574s2.52 5.574 5.625 5.574c3.11 0 5.63-2.496 5.63-5.574m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M12.43 15.242a5.64 5.64 0 0 0-4.285-1.617 5.58 5.58 0 0 0 5.277 5.867h.64a5.5 5.5 0 0 0-1.632-4.25m5.297-5.254a5.63 5.63 0 0 0-4.286-1.617 5.58 5.58 0 0 0 5.29 5.852c.214.015.43.015.64 0a5.5 5.5 0 0 0-1.644-4.235m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1dc",
    d: "M66.852 34.516c-3.82 0-4.165.097-4.348 2.195-3.399.82-1.574 4.187.789 6.125.875.71 2.836.644 4.512.644 1.632 0 3.449-.015 3.449-.968 0-1.614.465-2.57.465-4.348.008-3.098-1.04-3.648-4.867-3.648m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "M69.695 42.512h-4.672c-.972 0-1.59.277-1.59.933v1.133c0 .66.618 1.152 1.59 1.156h4.672c.887 0 1.696-.496 1.696-1.156v-1.133c0-.66-.809-.933-1.696-.933m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1dc",
    d: "M73.516 16.426a.6.6 0 0 1-.766.285l-5.21-2.094h-2.38l-.336.133-4.87 1.957a.59.59 0 0 1-.763-.281.7.7 0 0 1 .137-.168l5.512-4.84.336-.293h2.379l5.84 5.133c.046.05.09.105.12.168m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1dc",
    d: "M66.438 7.242c.71 0 1.285.574 1.285 1.281v10.891a1.284 1.284 0 1 1-2.567 0V8.524c0-.708.574-1.282 1.281-1.282m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9700",
    d: "m68.852 21.18-2.07-.383h-.669l-.355.066-1.727.317a.26.26 0 0 1-.285-.137.26.26 0 0 1 .05-.313l1.192-1.183.387-.387h2.148l1.575 1.57a.263.263 0 0 1-.246.45m0 0"
  }))));
};
export default SvgActivities;